<template>
  <div>
    <sub-nav v-if="filterListRoute.includes($route.name)" :route-list="filterList" :project-id="projectId"></sub-nav>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  components: {},
  data() {
    return {
      projectId: ""
    }
  },
  computed: {
    ...mapGetters(["hasPermission"]),
    filterList() {
      return [
        {
          route: "project_dashboard",
          name: "项目概况",
          right: true
        },
        {
          route: "project_employee",
          name: "项目人员",
          right: true
        },
        // {
        //   route: "site_list",
        //   name:"场所台账",
        //   right: true
        // },
        {
          route: "site_czw_list",
          name: "出租屋台账",
          right: true
        },
        {
          route: "site_sx_list",
          name: "三小场所台账",
          right: true
        },
        {
          route: "site_other_list",
          name: "其他场所台账",
          right: true
        },
        {
          route: "project_trouble",
          name: "项目隐患",
          right: true
        },
        {
          route: "rhzp",
          name: "入户照片",
          right: true
        },
        {
          route: "project_down",
          name: "下载",
          right: true
        },
        {
          route: "project_setting",
          name: "项目设置",
          right: true
        }
      ]
    },
    filterListRoute() {
      return this.filterList.map(v => v.route)
    },
  },
  methods: {
    setFirstRoute() {
      if (this.$route.name === "project_detail") {
        for (let item of this.filterList) {
          if (item.right) {
            this.$router.push({ name: item.route, params: this.$route.params })
            return
          }
        }
      }
    }
  },
  created() {
    this.projectId = this.$route.params.project_id;
    this.setFirstRoute()
  }
}
</script>

<style scoped></style>
